<!-- @veltra/icons generated sha256:fc45d101f3f57c3c gen:8 source:src/svg/colorful/fold.svg -->
<script setup lang="ts">
defineOptions({ name: 'Fold' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="#ffba53"
        d="M11.56 4.534H1.003v-.876C1.003 2.742 1.746 2 2.661 2h6.143a2.03 2.03 0 0 1 1.7.919z"
      />
      <path
        fill="#ffdc53"
        d="M15.003 6.2v5.586c0 1.22-.989 2.208-2.208 2.208H3.212a2.21 2.21 0 0 1-2.209-2.208V3.992h11.792c1.22 0 2.208.989 2.208 2.208"
      />
    </g>
  </svg>
</template>
